import { render, staticRenderFns } from "./UserCardContainer.vue?vue&type=template&id=37a6a6e1&scoped=true&"
import script from "./UserCardContainer.vue?vue&type=script&lang=js&"
export * from "./UserCardContainer.vue?vue&type=script&lang=js&"
import style0 from "./UserCardContainer.vue?vue&type=style&index=0&id=37a6a6e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a6a6e1",
  null
  
)

export default component.exports